// @flow
import React from 'react';
import { Modal } from '@shopify/polaris';
import { Field } from 'redux-form';
import { withI18n } from '@shopify/react-i18n';
import { RenderTextField } from 'src/components/views/common/forms/render-textfield';

type Props = {
  active: boolean,
  i18n: Object,
  title: string,
  description: string,
  loading?: boolean,
  tooltip?: string,
  pristine?: boolean,
  name: string,
  handleCancel: () => void,
  handleConfirm: () => void
};

const ModalAppKey: React.FC<Props> = ({
  i18n,
  title,
  description,
  loading,
  active,
  tooltip,
  name,
  pristine,
  handleCancel,
  handleConfirm
}) => {
  return (
    <Modal
      open={active}
      onClose={handleCancel}
      title={title}
      primaryAction={{
        content: i18n.translate('AdminHTML.Common.Action.submit'),
        loading: loading,
        disabled: pristine,
        onAction: handleConfirm
      }}
      secondaryActions={[
        {
          content: i18n.translate('AdminHTML.Common.Action.cancel'),
          onAction: handleCancel
        }
      ]}>
      <Modal.Section>
        <div className="BC-ModalAppKey">
          <p className="description">{description}</p>
          <Field
            name={name}
            component={RenderTextField}
            label={i18n.translate('AdminHTML.Integration.Integration.appKey')}
            placeholder={i18n.translate(
              'AdminHTML.Integration.Integration.appKeyPublic_Placeholder'
            )}
            tooltip={tooltip} //18n.translate('AdminHTML.Integration.Integration.appKey_Tooltip')
          />
        </div>
      </Modal.Section>
    </Modal>
  );
};

export default withI18n()(ModalAppKey);
